<template>
  <div class="gs-app gs-affiliate-settings">
    <div class="gs-affiliate-settings__content">
      <v-wait for="settings">
        <div>
          <header class="gs-affiliate-settings__header gs-wizard-card">
            <p class="gs-affiliate-settings__eyebrow">
              {{ $t('frontend_affiliate') }}
            </p>
            <h1>
              {{ $t('frontend_affiliate_settings_affiliate_settings') }}
            </h1>
            <p class="gs-affiliate-settings__subtitle">
              {{ $t('frontend_affiliate_settings_you_can_configure') }}
            </p>
          </header>

          <section class="gs-affiliate-settings__layout gs-wizard-card">
            <gd-tabs
              :tabs="affiliateSettingsTabs"
              :current-tab="affiliateSettingsTab"
              :wrapper-class="'gs-vtabs gs-affiliate-settings__tabs'"
              :tab-class="'gs-vtabs__item'"
              :tab-active-class="'is-active'"
              :line-class="'gs-affiliate-settings__tabs-line'"
              @onClick="handleAffiiateSettingsTabChange"
            />
            <div class="gs-affiliate-settings__panel">
              <general v-if="affiliateSettingsTab === 'general'" @update-form="HandleUpdateForm" :userId="userId"
                :validator="$v" :form="form" :saveAffiliateSettings="saveAffiliateSettings" />
              <payment v-else-if="affiliateSettingsTab === 'payment'" :saveAffiliateSettings="saveAffiliateSettings"
                :form="form" @update-form="HandleUpdateForm" />

              <tax v-else-if="affiliateSettingsTab === 'tax'" @update-form="HandleUpdateForm" :form="form"
                :saveAffiliateSettings="saveAffiliateSettings" :validator="$v" />
            </div>
          </section>
        </div>
      </v-wait>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Form from 'vform';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import {
  required,
  minLength,
  maxLength,
  alphaNum,
} from 'vuelidate/lib/validators';
import Notify from '@groovepages/gd-ui-kit/notify';

/** new components */
import General from './Settings_partials/tabs/General';
import Payment from './Settings_partials/tabs/Payment';
import Tax from './Settings_partials/tabs/Tax';

export default {
  middleware: 'auth',
  layout: 'defaultForAffiliates',
  components: {
    General,
    Payment,
    Tax,
  },
  data() {
    return {
      form: new Form({
        username: '',
        affiliate_paypal_email: '',
        affiliate_tax_id: '',
        affiliate_legal_name: '',
        affiliate_legal_address: '',
        affiliate_legal_address_2: '',
        affiliate_legal_city: '',
        affiliate_legal_state: '',
        affiliate_legal_country: '',
        affiliate_legal_zip_code: '',
        affiliate_tax_resident_type: 0,
        affiliate_tax_form: '',
      }),

      userId: 0,
      affiliateSettingsTabs: [
        {
          title: this.$t('frontend_affiliate_settings_general'),
          value: 'general',
        },
        {
          title: this.$t('frontend_affiliate_settings_payment'),
          value: 'payment',
        },
        {
          title: this.$t('frontend_affiliate_settings_tax_info'),
          value: 'tax',
        },
      ],
      affiliateSettingsTab: 'general',
    };
  },

  metaInfo() {
    return { title: this.$t('frontend_affiliate_settings_affiliate_settings') };
  },
  validations: {
    form: {
      username: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(255),
        async isUnique(value) {
          if (value === '') {
            return true;
          }

          let userNameFlag = false;

          await axios
            .get(`/validate-username/${value}`)
            .then(() => {
              userNameFlag = true;
            })
            .catch(() => {
              userNameFlag = false;
            });

          return userNameFlag;
        },
      },
      affiliate_legal_name: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(1000),
      },
      affiliate_legal_address: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(1000),
      },
      affiliate_legal_city: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(1000),
      },
      affiliate_legal_state: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(1000),
      },
      affiliate_legal_country: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(1000),
      },
      affiliate_legal_zip_code: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(1000),
      },
      affiliate_tax_id: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(1000),
      },
      affiliate_tax_resident_type: {
        required,
      },
      affiliate_tax_form: {
        required,
      },
    },
  },
  async created() {
    this.$wait.start('settings');
    const { data } = await axios.get('/affiliate-settings');
    this.userId = data.affiliate_id;
    this.form.username = data.username;
    this.form.affiliate_paypal_email = data.affiliate_paypal_email;
    this.form.affiliate_wire_info = data.affiliate_wire_info;
    this.form.affiliate_tax_id = data.affiliate_tax_id;
    this.form.affiliate_legal_name = data.affiliate_legal_name;
    this.form.affiliate_legal_address = data.affiliate_legal_address;
    this.form.affiliate_legal_address_2 = data.affiliate_legal_address_2;
    this.form.affiliate_legal_city = data.affiliate_legal_city;
    this.form.affiliate_legal_state = data.affiliate_legal_state;
    this.form.affiliate_legal_country = data.affiliate_legal_country;
    this.form.affiliate_legal_zip_code = data.affiliate_legal_zip_code;
    this.form.affiliate_tax_resident_type = data.affiliate_tax_resident_type;
    this.form.affiliate_tax_form = data.affiliate_tax_form;
    // await this.$v.$touch();
    this.$wait.end('settings');
  },
  methods: {
    HandleUpdateForm(newFormValue) {
      this.form = newFormValue;
    },

    handleAffiiateSettingsTabChange(newTab) {
      this.affiliateSettingsTab = newTab;
    },
    async saveAffiliateSettings() {;
      let isFormValid = true;
      if (this.affiliateSettingsTab == 'general') {
        this.$v.$touch();
        isFormValid = !this.$v.form.username.$$invalid;
      } else if (this.affiliateSettingsTab == 'tax') {
        this.$v.$touch();
        isFormValid =
          !this.$v.form.affiliate_legal_name.$invalid &&
          !this.$v.form.affiliate_legal_address.$invalid &&
          !this.$v.form.affiliate_legal_city.$invalid &&
          !this.$v.form.affiliate_legal_state.$invalid &&
          !this.$v.form.affiliate_legal_country.$invalid &&
          !this.$v.form.affiliate_legal_zip_code.$invalid &&
          !this.$v.form.affiliate_tax_resident_type.$invalid &&
          !this.$v.form.affiliate_tax_id.$invalid &&
          !this.$v.form.affiliate_tax_form.$invalid;
      }
      if (isFormValid) {
        const self = this;
        self.$loader.start('saveAffiliateSettings');

        await self.form
          .post(`${window.config.apiUrl}/save-affiliate-settings`)
          .then(() => {
            self.$loader.end('saveAffiliateSettings');
            Notify.success(this.$t('frontend_affiliate_settings_settings_saved_successfully'));
          })
          .catch(() => {
            self.$loader.end('saveAffiliateSettings');
            Notify.fail(this.$t('frontend_affiliate_settings_something_went_wrong'));
          });
      }
    },
  },
};
</script>

<style>
.dropzone .dz-preview .dz-progress {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  height: 20px !important;
}
</style>
<style scoped lang="scss">
/* Affiliate settings — page shell (same canvas as the other refreshed affiliate pages). */
.gs-affiliate-settings {
  min-height: 100%;
  padding: 28px;
  color: var(--gs-foreground);
  background: var(--gs-background);
}

.gs-affiliate-settings__content {
  max-width: 1120px;
  margin: 0 auto;
}

/* Header card + two-column layout card (mirrors pages/settings/index.vue). */
.gs-affiliate-settings .gs-wizard-card {
  padding: 20px 24px;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

.gs-affiliate-settings__eyebrow {
  margin: 0 0 4px;
  color: var(--gs-primary);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.gs-affiliate-settings__header h1 {
  margin: 0 0 6px;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
}

.gs-affiliate-settings__subtitle {
  margin: 0;
  color: var(--gs-muted-foreground);
  font-size: 14px;
}

.gs-affiliate-settings__layout {
  display: grid;
  grid-template-columns: 240px minmax(0, 1fr);
  gap: 28px;
  margin-top: 20px;
}

.gs-affiliate-settings__tabs {
  align-self: start;
}

.gs-affiliate-settings__panel {
  min-width: 0;
}

/* Everything below is rendered by child components (gd-tabs, the three tab
   partials and the third-party controls inside them), so it is bridged through
   the deep selector. Tokens only. */
.gs-affiliate-settings ::v-deep {
  /* ---- Vertical tabs: gd-tabs wearing the shared .gs-vtabs treatment ---- */
  .gs-vtabs {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .gs-vtabs__item {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 40px;
    padding: 8px 12px;
    color: var(--gs-muted-foreground);
    font-size: 15px;
    font-weight: 500;
    line-height: 1.25;
    text-align: left;
    background: transparent;
    border: 0;
    border-left: 3px solid transparent;
    border-radius: var(--gs-radius-sm);
    cursor: pointer;
    transition: background-color 120ms ease, color 120ms ease;
  }

  .gs-vtabs__item:hover {
    color: var(--gs-foreground);
    background: var(--gs-muted);
  }

  .gs-vtabs__item.is-active {
    color: var(--gs-foreground);
    font-weight: 700;
    background: var(--gs-primary-soft);
    border-left-color: var(--gs-primary);
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .gs-vtabs__item:focus {
    outline: none;
  }

  .gs-vtabs__item:focus-visible {
    box-shadow: 0 0 0 3px var(--gs-ring);
  }

  .gs-affiliate-settings__tabs-line {
    display: none;
  }

  /* ---- Tab shell (General / Payment / Tax) ---- */
  .gs-affiliate-settings-tab {
    min-width: 0;
    color: var(--gs-foreground);
  }

  .gs-affiliate-settings-tab__head {
    margin-bottom: 20px;
  }

  .gs-affiliate-settings-tab__head h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.3;
  }

  .gs-affiliate-settings-tab__body {
    max-width: 960px;
  }

  .gs-affiliate-settings-tab__body--narrow {
    max-width: 560px;
  }

  .gs-affiliate-settings-tab__footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid var(--gs-border);
  }

  /* ---- Field grid ---- */
  .gs-affiliate-settings__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px 20px;
  }

  .gs-affiliate-settings__grid .gs-field--span-2 {
    grid-column: 1 / -1;
  }

  .gs-affiliate-settings__stack {
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  /* Read-only value well (affiliate id). */
  .gs-affiliate-settings__well {
    display: flex;
    min-height: 40px;
    align-items: center;
    padding: 0 14px;
    color: var(--gs-foreground);
    font-family: var(--gs-font-mono);
    font-size: 13px;
    background: var(--gs-surface-subtle);
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-sm);
  }

  /* ---- Segmented control (Payment: PayPal | Wire) — restyles nested gd-tabs ---- */
  .gs-affiliate-settings__segmented {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
  }

  .gs-affiliate-settings__segment {
    min-height: 38px;
    padding: 0 16px;
    color: var(--gs-muted-foreground);
    font-size: 14px;
    font-weight: 600;
    background: var(--gs-surface);
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-md);
    cursor: pointer;
    transition: background-color 120ms ease, color 120ms ease, border-color 120ms ease;
  }

  .gs-affiliate-settings__segment:hover {
    color: var(--gs-foreground);
    background: var(--gs-muted);
  }

  .gs-affiliate-settings__segment:focus {
    outline: none;
  }

  .gs-affiliate-settings__segment:focus-visible {
    box-shadow: 0 0 0 3px var(--gs-ring);
  }

  .gs-affiliate-settings__segment.is-active {
    color: var(--gs-active);
    background: var(--gs-active-soft);
    border-color: var(--gs-active-border);
  }

  .gs-affiliate-settings__segment-line {
    display: none;
  }

  /* ---- Radio cards (Tax: citizenship status) ---- */
  .gs-affiliate-settings__radio-cards {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    margin: 0;
    padding: 0;
    border: 0;
  }

  .gs-affiliate-settings__radio-card {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    color: var(--gs-foreground);
    font-size: 14px;
    font-weight: 650;
    line-height: 1.35;
    background: var(--gs-surface);
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-md);
    cursor: pointer;
    transition: background-color 120ms ease, border-color 120ms ease;
  }

  .gs-affiliate-settings__radio-card:hover {
    background: var(--gs-surface-subtle);
  }

  .gs-affiliate-settings__radio-card.is-active {
    background: var(--gs-active-soft);
    border-color: var(--gs-active-border);
  }

  .gs-affiliate-settings__radio-card:focus-within {
    box-shadow: 0 0 0 3px var(--gs-ring);
  }

  .gs-affiliate-settings__radio-card p {
    margin: 0;
  }

  .gs-affiliate-settings__radio-dot {
    display: inline-block;
    width: 18px;
    height: 18px;
    flex: 0 0 auto;
    background: var(--gs-surface);
    border: 1.5px solid var(--gs-border-strong);
    border-radius: 999px;
  }

  .gs-affiliate-settings__radio-card.is-active .gs-affiliate-settings__radio-dot {
    border-color: var(--gs-active);
    box-shadow: inset 0 0 0 4px var(--gs-active);
  }

  /* ---- Existing tax form well ---- */
  .gs-affiliate-settings__form-well {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px 16px;
    padding: 16px 18px;
    background: var(--gs-surface-subtle);
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-md);
  }

  .gs-affiliate-settings__form-status {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 15px;
    font-weight: 650;
  }

  .gs-affiliate-settings__form-check {
    display: grid;
    width: 22px;
    height: 22px;
    flex: 0 0 auto;
    place-items: center;
    color: var(--gs-primary-foreground);
    background: var(--gs-success);
    border-radius: 999px;
  }

  .gs-affiliate-settings__form-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  /* ---- Numbered step cards (W-9 / W-8BEN flow) ---- */
  .gs-affiliate-settings__steps {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .gs-affiliate-settings__step {
    display: grid;
    grid-template-columns: 24px minmax(0, 1fr);
    gap: 14px;
    padding: 16px 18px;
    background: var(--gs-surface);
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-md);
  }

  .gs-affiliate-settings__step-badge {
    display: grid;
    width: 24px;
    height: 24px;
    place-items: center;
    color: var(--gs-foreground);
    font-size: 12px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    background: var(--gs-muted);
    border-radius: 999px;
  }

  .gs-affiliate-settings__step-body {
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: 12px;
  }

  .gs-affiliate-settings__step-body > p {
    margin: 0;
    font-size: 14px;
    line-height: 1.55;
  }

  .gs-affiliate-settings__step-body > p strong {
    font-weight: 700;
  }

  .gs-affiliate-settings__step-action {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
  }

  /* gd-dropdown (W-8BEN picker): restyle its trigger as an outline button. */
  .gs-affiliate-settings__w8-dropdown {
    width: 100%;
    max-width: 300px;
  }

  .gs-affiliate-settings__w8-dropdown > .relative > div:first-child {
    min-height: 40px;
    color: var(--gs-foreground);
    background: var(--gs-surface);
    border: 1px solid var(--gs-border-strong);
    border-radius: var(--gs-radius-md);
    transition: background-color 120ms ease;
  }

  .gs-affiliate-settings__w8-dropdown > .relative > div:first-child:hover {
    background: var(--gs-muted);
  }

  .gs-affiliate-settings__w8-dropdown > .relative > div:first-child > span:first-child {
    color: var(--gs-foreground);
    font-size: 14px;
    font-weight: 700;
    opacity: 1;
  }

  .gs-affiliate-settings__w8-dropdown > .relative > div:first-child > span:last-child {
    color: var(--gs-muted-foreground);
  }

  .gs-affiliate-settings__w8-dropdown > .relative > div:last-child {
    color: var(--gs-foreground);
    font-size: 14px;
    border-color: var(--gs-border);
    border-radius: var(--gs-radius-md);
    box-shadow: var(--gs-shadow-md);
  }

  /* ---- Dropzone (tokenised) ---- */
  #customdropzone {
    width: 100%;
  }

  .vue-dropzone {
    min-height: 0;
    padding: 0;
    color: var(--gs-muted-foreground);
    font-family: inherit;
    letter-spacing: normal;
    background: var(--gs-surface-subtle);
    border: 2px dashed var(--gs-border-strong);
    border-radius: var(--gs-radius-md);
    transition: background-color 150ms ease, border-color 150ms ease;
  }

  .vue-dropzone:hover {
    background: var(--gs-surface-subtle);
    border-color: var(--gs-primary);
  }

  .vue-dropzone.dz-drag-hover {
    background: var(--gs-primary-soft);
    border-color: var(--gs-primary);
  }

  .vue-dropzone .dz-message {
    margin: 0;
  }

  .gs-affiliate-settings__dropzone-content {
    display: flex;
    min-height: 160px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 20px 16px;
    color: var(--gs-muted-foreground);
    font-size: 13px;
    text-align: center;
  }

  .gs-affiliate-settings__dropzone-title {
    color: var(--gs-foreground);
    font-size: 14px;
    font-weight: 650;
  }

  .gs-affiliate-settings__upload-actions {
    display: flex;
    justify-content: center;
  }

  @media (max-width: 640px) {
    .gs-affiliate-settings__grid,
    .gs-affiliate-settings__radio-cards {
      grid-template-columns: 1fr;
    }

    .gs-affiliate-settings__form-well {
      flex-direction: column;
      align-items: flex-start;
    }
  }
}

@media (max-width: 900px) {
  .gs-affiliate-settings__layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .gs-affiliate-settings {
    padding: 16px;
  }
}
</style>
